import ExtraLayoutSlider from './ExtraLayoutSlider';
export default ExtraLayoutSlider;
